import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "lodash-es";
import FileService from "services/FileService";
import OCRService from "services/OCRService";
import PersonalService from "services/PersonalService";
import VisaFormService from "services/VisaFormService";

export const getSmartServiceList = createAsyncThunk(
  "visaForm/getSmartServiceList",
  async () => {
    const response = await VisaFormService.getSmartserviceList();
    return response?.results;
  }
);

export const getDocumentRequired = createAsyncThunk(
  "visaForm/getDocumentRequired",
  async ({ smartserviceId, ConditionType, isUpload }) => {
    const response = await VisaFormService.getDocumentRequired({
      smartserviceId,
      ConditionType,
      isUpload,
    });
    return response?.results;
  }
);

export const getDocumentrequiredbydraftid = createAsyncThunk(
  "visaForm/getDocumentrequiredbydraftid",
  async ({ draftId, isUpload }) => {
    const response = await VisaFormService.getDocumentrequiredbydraftid({
      draftId,
      isUpload,
    });
    return response?.results;
  }
);

export const getCoditionVisa = createAsyncThunk(
  "visaForm/getCoditionVisa",
  async ({ smartserviceId, smartVisaServiceId, ConditionType }) => {
    const response = await VisaFormService.getCoditionvisa({
      smartserviceId: smartserviceId || smartVisaServiceId,
      ConditionType,
    });
    return response?.results;
  }
);

export const getCoditionType = createAsyncThunk(
  "visaForm/getCoditionType",
  async ({ smartserviceId }) => {
    const response = await VisaFormService.getCoditionType({ smartserviceId });
    return response?.results;
  }
);

export const getSmartFormFieldConfig = createAsyncThunk(
  "visaForm/getSmartFormFieldConfig",
  async ({ smartserviceId, partfromId }) => {
    const response = await VisaFormService.getSmartFormFieldConfig({
      smartserviceId,
      partfromId,
    });
    return response?.results;
  }
);

export const addPopupSmartForm = createAsyncThunk(
  "visaForm/addPopupSmartForm",
  async ({ data, images }, store) => {
    let detailImage = [];

    if (images && images.length) {
      const responseImages = await Promise.all(
        images
          .filter((value) => value.file)
          .map(({ file }) => FileService.uploadFile({ file, Status: true }))
      );
      const responseOCRImages = await Promise.all(
        images
          .filter((value) => value.file)
          .map(({ file }) => OCRService.read(file))
      );
      const imageIds = responseImages.map((v) => v?.results?.fileID);
      const ocrTexts = responseOCRImages.map((v) => v?.results);

      detailImage = images
        .filter((value) => value.file)
        .map((image, index) => ({
          partfromId: null,
          configsmartId: null,
          linkTable: "",
          value: null,
          configDocumentRequiredID: null,
          // ---
          smartId: null,
          configConditionVisaId: image.configConditionVisaId,
          ocRtext: ocrTexts[index] || "",
          fileID: imageIds[index] || null,
          status: true,
        }));
    }

    const response = await VisaFormService.addSmartForm({
      ...data,
      detail: [...data.detail, ...detailImage],
    });

    return response?.results;
  }
);

export const addSmartForm = createAsyncThunk(
  "visaForm/addSmartForm",
  async ({ data }) => {
    const response = await VisaFormService.addSmartForm(data);
    return response?.results;
  }
);

export const getSmartForm = createAsyncThunk(
  "visaForm/getSmartForm",
  async ({ personalId, smartserviceId, draftId }) => {
    console.log(personalId);
    const response = await VisaFormService.getSmartForm({
      personalId,
      smartserviceId,
      draftId,
    });
    return response?.results;
  }
);

export const uploadPassport = createAsyncThunk(
  "visaForm/uploadPassport",
  async (file, { getState }) => {
    const personalID =
      get(getState().personal, "detail.personalID", null) || null;
    const fileResponse = await FileService.uploadFile({
      file,
      Status: true,
    });
    const response = await PersonalService.addPassportPersonal({
      passportID: "",
      personalID: personalID,
      FileID: fileResponse.results.fileID,
      status: true,
    });
    return response?.results;
  }
);

export const getListSmartForm = createAsyncThunk(
  "visaForm/getListSmartForm",
  async (params, { getState }) => {
    const personalId =
      get(getState().personal, "detail.personalID", null) || null;
    console.log(personalId);
    const response = await VisaFormService.getListSmartForm({ personalId });
    return response?.results;
  }
);

export const submitSmartForm = createAsyncThunk(
  "visaForm/submitSmartForm",
  async ({ detail }, { getState }) => {
    console.log(detail);
    const response = await VisaFormService.submitSmartForm({ detail });
    return response?.results;
  }
);

export const smartFormChange = createAsyncThunk(
  "visaForm/smartFormChange",
  async ({ personalId }, { getState }) => {
    const response = await VisaFormService.smartFormChange({ personalId });
    return response?.results;
  }
);

export const getExtension = createAsyncThunk(
  "visaForm/getExtension",
  async ({ personalId }) => {
    const response = await VisaFormService.smartfromExtension({ personalId });
    return response?.results;
  }
);

export const addExtension = createAsyncThunk(
  "visaForm/addExtension",
  async (data) => {
    const response = await VisaFormService.addExtension(data);
    return response?.results;
  }
);

export const checkSmartO = createAsyncThunk(
  "visaForm/checkSmartO",
  async (data) => {
    const response = await VisaFormService.checkSmartO(data);
    return response?.results;
  }
);

export const reqdoclogList = createAsyncThunk(
  "visaForm/reqdoclogList",
  async (data) => {
    const response = await VisaFormService.reqdoclogList(data);
    return response?.results;
  }
);

export const getVisaRequest = createAsyncThunk(
  "visaForm/getVisaRequest",
  async ({ smartserviceId }) => {
    const response = await VisaFormService.getVisaRequest({ smartserviceId });
    return response?.results;
  }
);

export const addTerminateSmartForm = createAsyncThunk(
  "visaForm/addTerminateSmartForm",
  async ({ data }) => {
    const response = await VisaFormService.addTerminateSmartForm(data);
    return response?.results;
  }
);

export const smartfromExtensionClone = createAsyncThunk(
  "visaForm/smartfromExtensionClone",
  async (data) => {
    const response = await VisaFormService.smartfromExtensionClone(data);
    return response?.results;
  }
);

export const addSmartfromExtension = createAsyncThunk(
  "visaForm/addSmartfromExtension",
  async ({ data }) => {
    const response = await VisaFormService.addSmartfromExtension(data);
    return response?.results;
  }
);
